import { Component } from 'san';

import { IOrganization } from 'src/models';
import organizationService from 'src/services/organization.service';

export default class CheckLatelyOrganization extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        checkedItem: IOrganization; // {{}}
        items: IOrganization[];
    } {
        return {
            checkedItem: null,
            items: []
        };
    }

    inited() {
        this.getLatelyOrganizations();
    }

    private getLatelyOrganizations() {
        organizationService.getLatelyOrganizations().then(items => {
            this.data.splice('items', [0, this.data.get('items').length, ...items]);
        });
    }

    checkOrganization(organization: IOrganization) {
        this.dispatch('UI:check-lately-organization-changed', organization);
    }
}